module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/ant-english.18e4bd25.jpg";